<mbs-modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="'wizards:compression_encryption_step_title' | i18next">
  <ng-container modal-body>
    @if (ready()) {
      <mbs-compression-encryption-step
        [isS3Selected]="isS3Selected()"
        [(ngModel)]="value"></mbs-compression-encryption-step>
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>

    <mbs-button
      data-dismiss="modal"
      [type]="'secondary'"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
